module.exports = __webpack_public_path__ + "static/media/shelf.53d9a431.jpg";